import { render } from "./Footer.vue?vue&type=template&id=4922c640&scoped=true"
import script from "./Footer.vue?vue&type=script&lang=js"
export * from "./Footer.vue?vue&type=script&lang=js"

import "@/styles/footer.css?vue&type=style&index=0&id=4922c640&scoped=true&lang=css&external"
import "@/styles/common.css?vue&type=style&index=1&id=4922c640&scoped=true&lang=css&external"
import "./Footer.vue?vue&type=style&index=2&id=4922c640&scoped=true&lang=css"

import exportComponent from "../../../../../../../../../worktrees/adel01/tcd-userpage-new/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4922c640"]])

export default __exports__